import { ChangeDetectorRef, Component, computed, signal, ViewChild, inject } from '@angular/core';
import { ImportNzIdWizardUploadService } from '../service/import-nz-id-wizard-upload.service';
import { MatStepper } from '@angular/material/stepper';
import { NetzzuordnungIdImportReport } from '../model/netzzuordnung-id-import-report';
import { ErzeugungsanlagenRefreshService } from '../../service/erzeugungsanlage/erzeugungsanlagen-refresh.service';
import { NetzzuordnungIdImportJob, NetzzuordnungIdImportJobPhase } from '../../domain/model/netzzuordnung-id-import-job';
import { ImportWizardDialogService } from '../../ea-import-wizard/service/import-wizard-dialog.service';

@Component({
    selector: 'tnb-nz-id-import-wizard',
    templateUrl: './import-nz-id-wizard.component.html',
    styleUrls: [
        './import-nz-id-wizard.component.scss',
    ],
    standalone: false,
})
export class ImportNzIdWizardComponent {
    private uploadService = inject(ImportNzIdWizardUploadService);
    private erzeugungsanlagenRefreshService = inject(ErzeugungsanlagenRefreshService);
    private dialogService = inject(ImportWizardDialogService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    protected job = signal<NetzzuordnungIdImportJob | null>(null);
    protected progress = computed(() => {
        const job = this.job();
        if (!job) {
            return 0;
        }
        if (job.rowsTotal) {
            return ((job.nrStoredNetzzuordnungIds ?? 0) / job.rowsTotal) * 100;
        }
        return 100;
    });

    @ViewChild('stepper', { static: true })
    protected stepper: MatStepper;

    protected loading = false;
    protected jobId?: number;
    protected importReport: NetzzuordnungIdImportReport | null = null;
    protected backendFailure: any = null;
    protected selectedFile: File;
    protected readonly NetzzuordnungIdImportJobPhase = NetzzuordnungIdImportJobPhase;

    private jobCheckerTimeout: any;

    handleFileChange(selectedFile: File): void {
        this.selectedFile = selectedFile;
    }

    async upload(dryRun: boolean) {
        this.job.set(null);
        this.loading = true;
        this.importReport = null;
        this.backendFailure = null;

        this.stepper.next();

        try {
            this.jobId = await this.uploadService.uploadCsvAsync(
                this.selectedFile,
                dryRun,
            );
            this.jobCheckerTimeout = setInterval(() => this.checkJobDone(dryRun), 756);
            await this.checkJobDone(dryRun);

        } catch (e) {
            console.error(e);
            this.backendFailure = e;
        } finally {
            this.loading = false;
        }
    }

    close(): void {
        this.dialogService.close();
    }

    private async checkJobDone(dryRun: boolean) {
        try {
            const job = await this.uploadService.checkImportJob(this.jobId);
            this.job.set(job);
            this.loading = false;
            if (job.finished) {
                clearInterval(this.jobCheckerTimeout);
                if (job.report) {
                    setTimeout(() => {
                        // the finalization is so quick that the user doesn't see all the checkboxes green,
                        // so the timeout is just for the feel :)
                        this.importReport = JSON.parse(job.report);
                        this.changeDetectorRef.markForCheck();
                    }, 842);
                    if (!dryRun) {
                        this.erzeugungsanlagenRefreshService.requestRefresh();
                    }
                } else {
                    this.backendFailure = {};
                }
            }
        } catch (e) {
            clearInterval(this.jobCheckerTimeout);
            this.backendFailure = e;
        }
        this.changeDetectorRef.markForCheck();
    }
}
